import React from 'react'
import './styles/NotSupported.css'

const NotSupportedScreen = () => {
  return (
    <div className='not-supported'>
      <div className='not-supported-text'>
            <h4 style={{ margin: '1rem' }}>
              I'm afraid, this device is too small. I need more room.
            </h4>
      </div>
    </div>
  )
}

export default NotSupportedScreen
